















































import { Component, Prop, Vue } from 'vue-property-decorator'
import NavBarStore from '../stores/NavBar'
import MenuStore from '../stores/Menu'

// @ts-ignore
@Component({
  store: {
    NavBarStore,
    MenuStore,
  }
})

export default class ComponentMenu extends Vue {
  stores: any = {
    navBar: (this.$store as any).NavBarStore,
    menuStore: (this.$store as any).MenuStore,
  }

  get rotas() {
    return this.stores.navBar.getters.ROTAS
  }

  get show() {
    return this.stores.menuStore.getters.SHOW
  }

  set show(newValue) {}

  close() {
    this.stores.menuStore.commit('SHOW', false)
  }

  to(url) {
    this.stores.menuStore.commit('SHOW', false)
    this.$router.push(url)
  }

  items: Array<any> = [
    { title: 'Calculadora', icon: 'phone_android', url: '/calculadora' },
    { title: 'Perfil', icon: 'account_box', url: '/perfil' },
  ]
}
